import { render, staticRenderFns } from "./Catching.vue?vue&type=template&id=d1c08928&scoped=true"
import script from "./Catching.vue?vue&type=script&lang=js"
export * from "./Catching.vue?vue&type=script&lang=js"
import style0 from "./Catching.vue?vue&type=style&index=0&id=d1c08928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c08928",
  null
  
)

export default component.exports